import React from "react";
import {Modulator} from "../stores/Modulator";
import {observer} from "mobx-react-lite";
import {
    WAVEFORM_SAMPLEHOLD_NAME,
    WAVEFORM_SAW_NAME,
    WAVEFORM_SIN_NAME,
    WAVEFORM_SQUARE_NAME,
    WAVEFORM_TRIANGLE_NAME
} from "../waveforms";
import { ReactComponent as SinIcon } from '../img/sin.svg';
import { ReactComponent as SawIcon } from '../img/saw.svg';
import { ReactComponent as TriangleIcon } from '../img/triangle.svg';
import { ReactComponent as SquareIcon } from '../img/square.svg';
import { ReactComponent as SampleHoldIcon } from '../img/sampleHold.svg';

interface WaveSelectorProps {
    modulator: Modulator;
}

export const WaveSelector = observer(({modulator}: WaveSelectorProps) => {

    const selectWaveform = (fname: string) => {
        modulator.setF(fname);
    }

    return (
        <div className="wave-selection">
            <div className={`${modulator.fName === WAVEFORM_SIN_NAME ? 'selected-waveform' : ''}`} onClick={() => selectWaveform(WAVEFORM_SIN_NAME)}>
                <SinIcon />
            </div>
            <div className={`${modulator.fName === WAVEFORM_SAW_NAME ? 'selected-waveform' : ''}`} onClick={() => selectWaveform(WAVEFORM_SAW_NAME)}>
                <SawIcon />
            </div>
            <div className={`${modulator.fName === WAVEFORM_TRIANGLE_NAME ? 'selected-waveform' : ''}`} onClick={() => selectWaveform(WAVEFORM_TRIANGLE_NAME)}>
                <TriangleIcon />
            </div>
            <div className={`${modulator.fName === WAVEFORM_SQUARE_NAME ? 'selected-waveform' : ''}`} onClick={() => selectWaveform(WAVEFORM_SQUARE_NAME)}>
                <SquareIcon />
            </div>
            <div className={`${modulator.fName === WAVEFORM_SAMPLEHOLD_NAME ? 'selected-waveform' : ''}`} onClick={() => selectWaveform(WAVEFORM_SAMPLEHOLD_NAME)}>
                <SampleHoldIcon />
            </div>
        </div>
    );

});
